export default __webpack_public_path__ + "static/media/AddRefBanner-Mobile.53f1e74d.svg";